<form [formGroup]="selectTypeForm">
  <div class="cg-margin-top-xl cg-margin-bottom-lg">
    <h3 class="cg-h5 cg-margin-bottom-sm" data-test="lob-header">
      Line of Business
    </h3>
    <p>
      {{ prompt }}
    </p>
    <div>
      <label class="chcp-radio cg-margin-right-md" for="patientTypeCommercial">
        <input
          type="radio"
          id="patientTypeCommercial"
          [formControl]="patientType"
          value="commercial"
          (click)="this.onCommercialLobSelected()"
          data-test="commercial-type"
          class="chcp-radio"
        />
        <i class="chcp-radio-img"></i>
        <span class="chcp-radio-label" data-test="rad-commercial-type"
          >Commercial</span
        >
      </label>
      <label class="chcp-radio" for="patientTypeMedicare">
        <input
          type="radio"
          id="patientTypeMedicare"
          [formControl]="patientType"
          value="medicare"
          (click)="onMedicareLobSelected()"
          data-test="medicare-type"
          class="chcp-radio"
        />
        <i class="chcp-radio-img"></i>
        <span class="chcp-radio-label" data-test="rad-medicare-type"
          >Medicare</span
        >
      </label>
    </div>
  </div>
</form>
